'use client';

import { MaterialIcon } from '../../../components/MaterialIcon';
import { ProductDetailsTableKeyValueRow } from './ProductDetailsTableKeyValueRow';

type ProductDetailsExpandableListProps = {
  list: string[];
  expanded: boolean;
  onToggle: () => void;
  icon?: JSX.Element;
  seeMoreText: string;
  seeLessText: string;
};

export const ProductDetailsExpandableList: React.FC<
  ProductDetailsExpandableListProps
> = ({ list, expanded, onToggle, icon, seeMoreText, seeLessText }) => {
  const shouldCollapse = list.length > 3;
  const visibleItems = expanded ? list : list.slice(0, 3);

  return (
    <div
      className="flex flex-col gap-spacing/gap/x"
      data-component="pdp-expandable-list"
    >
      {visibleItems.map((item, index) => (
        <ProductDetailsTableKeyValueRow
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          label={item}
          icon={icon}
          hiddenBorder={index === visibleItems.length - 1}
        />
      ))}

      {shouldCollapse && (
        <button
          type="button"
          onClick={onToggle}
          className="flex items-center gap-2 mhg-alpha-typography-body-2-relaxed text-text/primary"
        >
          {expanded ? seeLessText : seeMoreText}

          <MaterialIcon
            icon="expand_more"
            className={`transition-transform ${expanded ? 'rotate-180' : ''}`}
          />
        </button>
      )}
    </div>
  );
};
